import * as React from 'react';
import { Debt } from '../../../models/debt';
import * as styles from './DebtList.css';
import history from '../../../history';
import Hidden from '@material-ui/core/Hidden/Hidden';
import Grid from '@material-ui/core/Grid/Grid';
import { debtTypeMap } from '../../AddDebt/AddDebtForm/debtTypes';
import { find, propEq } from 'ramda';
import logo from '../../shared/blueLogo.png';
import Typography from '@material-ui/core/Typography/Typography';
import withTheme, { WithTheme } from '@material-ui/core/styles/withTheme';
import { numberWithCommas } from '../../shared/format';

interface DebtListProps {
  debts: Debt[];
}

const DebtList = ({ debts, theme }: DebtListProps & WithTheme) => (
  <>
    {debts.length > 0 ? (
      <div className={styles.container}>
        <Grid container className={styles.header}>
          <Grid item container justify="center" xs>
            <b>DEBT</b>
          </Grid>
          <Grid item container justify="center" xs>
            <b>BALANCE</b>
          </Grid>
          <Grid item container justify="center" xs>
            <b>PAYMENT DUE</b>
          </Grid>
          <Hidden xsDown>
            <Grid item container justify="center" xs>
              <b>% PAID OFF</b>
            </Grid>
          </Hidden>
          <Hidden smDown>
            <Grid item container justify="center" xs>
              <b>TYPE</b>
            </Grid>
          </Hidden>
          <Hidden mdDown>
            <Grid item container justify="center" xs>
              <b>APR %</b>
            </Grid>
          </Hidden>
        </Grid>
        {debts.map(
          ({
            id,
            name,
            balance,
            minimumPayment,
            paidThisMonth,
            percentBalanceChange,
            type,
            apr,
          }) => (
            <Grid
              key={id}
              container
              onClick={() => history.push(`/debt/${id}`)}
              className={styles.debt}>
              <Grid item container justify="center" xs>
                <span className={styles.debtName} style={{ color: theme.palette.primary.light }}>
                  {name}
                </span>
              </Grid>
              <Grid item container justify="center" xs>
                {'$' + numberWithCommas(Number(balance).toFixed(2))}
              </Grid>
              <Grid item container justify="center" xs>
                {minimumPayment ? '$' + Number(minimumPayment).toFixed(2) : '-'}
              </Grid>

              <Hidden xsDown>
                <Grid item container justify="center" xs>
                  {Number(percentBalanceChange * 100).toFixed(2) + '%'}
                </Grid>
              </Hidden>

              <Hidden smDown>
                <Grid item container justify="center" xs>
                  {type ? find(propEq(type, 'value'))(debtTypeMap).name : '-'}
                </Grid>
              </Hidden>

              <Hidden mdDown>
                <Grid item container justify="center" xs>
                  {apr ? Number(apr * 100).toFixed(2) + '%' : '-'}
                </Grid>
              </Hidden>
            </Grid>
          )
        )}
      </div>
    ) : (
      <Grid container direction="column" justify="space-between" alignItems="center">
        <img className={styles.logo} src={logo} />
        <Typography className={styles.noDebtText} variant="headline">
          You don't seem to have any debts added yet.
        </Typography>
      </Grid>
    )}
  </>
);

export default withTheme()(DebtList);
